export default {
  init() {
    // console.log('about');
  },
  finalize() {
    // JavaScript to be fired on the about page, after the init JS
    // console.log('about finalize');
  },
};
